import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseInputEditor } from './base-editor';
import { CELL_EDITOR_STYLES } from './cell-editor.styles';

@Component({
  selector: 'ct-text-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [CELL_EDITOR_STYLES],
  template: `
    <input #editInput type="text" class="cell-input"
      [(ngModel)]="editingValue"
      (keydown)="onKeydown($event)"
      [attr.aria-label]="'Editing ' + column.label"
      [attr.aria-describedby]="ariaDescribedBy"
      [attr.aria-invalid]="hasError || null"
      [attr.aria-required]="isRequired || null" />
  `,
})
export class TextEditorComponent extends BaseInputEditor {}
